import React from 'react';

import {
  JobReviewFiltersContextProvider,
  jobReviewDefaultFilters,
} from 'modules/job-review/filters/context';

import { JobReviewServiceContext } from 'modules/job-review/service';

const JobReviewProvider = ({ children }) => {
  return (
    <JobReviewFiltersContextProvider defaultFilters={jobReviewDefaultFilters}>
      {({ filters }) => (
        <JobReviewServiceContext.Provider value={{ filters }}>
          {children}
        </JobReviewServiceContext.Provider>
      )}
    </JobReviewFiltersContextProvider>
  );
};

export { JobReviewProvider };
